import * as Tone from "tone";

// Interface for multi-key instruments
export interface MultiKeyInstrument {
  id: string;
  name: string;
  category: string;
  samples: { [note: string]: string }; // Maps note names to file paths
  baseUrl?: string;
}

// Multi-key instruments from the public/samples folder
export const MULTI_KEY_INSTRUMENTS: MultiKeyInstrument[] = [
  {
    id: "2ravie",
    name: "2ravie",
    category: "unknown",
    samples: {
      "a#1": "/samples/2Ravie-a#1.mp3",
      "a#2": "/samples/2Ravie-a#2.mp3",
      "a#3": "/samples/2Ravie-a#3.mp3",
      "a#4": "/samples/2Ravie-a#4.mp3",
      "a#5": "/samples/2Ravie-a#5.mp3",
      "a1": "/samples/2Ravie-a1.mp3",
      "a2": "/samples/2Ravie-a2.mp3",
      "a3": "/samples/2Ravie-a3.mp3",
      "a4": "/samples/2Ravie-a4.mp3",
      "a5": "/samples/2Ravie-a5.mp3",
      "c#1": "/samples/2Ravie-c#1.mp3",
      "c#2": "/samples/2Ravie-c#2.mp3",
      "c#3": "/samples/2Ravie-c#3.mp3",
      "c#4": "/samples/2Ravie-c#4.mp3",
      "c#5": "/samples/2Ravie-c#5.mp3",
      "c1": "/samples/2Ravie-c1.mp3",
      "c2": "/samples/2Ravie-c2.mp3",
      "c3": "/samples/2Ravie-c3.mp3",
      "c4": "/samples/2Ravie-c4.mp3",
      "c5": "/samples/2Ravie-c5.mp3",
      "c6": "/samples/2Ravie-c6.mp3",
      "d#1": "/samples/2Ravie-d#1.mp3",
      "d#2": "/samples/2Ravie-d#2.mp3",
      "d#3": "/samples/2Ravie-d#3.mp3",
      "d#4": "/samples/2Ravie-d#4.mp3",
      "d#5": "/samples/2Ravie-d#5.mp3",
      "d1": "/samples/2Ravie-d1.mp3",
      "d2": "/samples/2Ravie-d2.mp3",
      "d3": "/samples/2Ravie-d3.mp3",
      "d4": "/samples/2Ravie-d4.mp3",
      "d5": "/samples/2Ravie-d5.mp3",
      "e1": "/samples/2Ravie-e1.mp3",
      "e2": "/samples/2Ravie-e2.mp3",
      "e3": "/samples/2Ravie-e3.mp3",
      "e4": "/samples/2Ravie-e4.mp3",
      "e5": "/samples/2Ravie-e5.mp3",
      "f#1": "/samples/2Ravie-f#1.mp3",
      "f#2": "/samples/2Ravie-f#2.mp3",
      "f#3": "/samples/2Ravie-f#3.mp3",
      "f#4": "/samples/2Ravie-f#4.mp3",
      "f#5": "/samples/2Ravie-f#5.mp3",
      "f1": "/samples/2Ravie-f1.mp3",
      "f2": "/samples/2Ravie-f2.mp3",
      "f3": "/samples/2Ravie-f3.mp3",
      "f4": "/samples/2Ravie-f4.mp3",
      "f5": "/samples/2Ravie-f5.mp3",
      "g#1": "/samples/2Ravie-g#1.mp3",
      "g#2": "/samples/2Ravie-g#2.mp3",
      "g#3": "/samples/2Ravie-g#3.mp3",
      "g#4": "/samples/2Ravie-g#4.mp3",
      "g#5": "/samples/2Ravie-g#5.mp3",
      "g1": "/samples/2Ravie-g1.mp3",
      "g2": "/samples/2Ravie-g2.mp3",
      "g3": "/samples/2Ravie-g3.mp3",
      "g4": "/samples/2Ravie-g4.mp3",
      "g5": "/samples/2Ravie-g5.mp3"
    },
  },
  {
    id: "big brass",
    name: "Big brass",
    category: "unknown",
    samples: {
      "a#1": "/samples/Big Brass-a#1.mp3",
      "a#2": "/samples/Big Brass-a#2.mp3",
      "a#3": "/samples/Big Brass-a#3.mp3",
      "a#4": "/samples/Big Brass-a#4.mp3",
      "a#5": "/samples/Big Brass-a#5.mp3",
      "a1": "/samples/Big Brass-a1.mp3",
      "a2": "/samples/Big Brass-a2.mp3",
      "a3": "/samples/Big Brass-a3.mp3",
      "a4": "/samples/Big Brass-a4.mp3",
      "a5": "/samples/Big Brass-a5.mp3",
      "c#1": "/samples/Big Brass-c#1.mp3",
      "c#2": "/samples/Big Brass-c#2.mp3",
      "c#3": "/samples/Big Brass-c#3.mp3",
      "c#4": "/samples/Big Brass-c#4.mp3",
      "c#5": "/samples/Big Brass-c#5.mp3",
      "c1": "/samples/Big Brass-c1.mp3",
      "c2": "/samples/Big Brass-c2.mp3",
      "c3": "/samples/Big Brass-c3.mp3",
      "c4": "/samples/Big Brass-c4.mp3",
      "c5": "/samples/Big Brass-c5.mp3",
      "c6": "/samples/Big Brass-c6.mp3",
      "d#1": "/samples/Big Brass-d#1.mp3",
      "d#2": "/samples/Big Brass-d#2.mp3",
      "d#3": "/samples/Big Brass-d#3.mp3",
      "d#4": "/samples/Big Brass-d#4.mp3",
      "d#5": "/samples/Big Brass-d#5.mp3",
      "d1": "/samples/Big Brass-d1.mp3",
      "d2": "/samples/Big Brass-d2.mp3",
      "d3": "/samples/Big Brass-d3.mp3",
      "d4": "/samples/Big Brass-d4.mp3",
      "d5": "/samples/Big Brass-d5.mp3",
      "e1": "/samples/Big Brass-e1.mp3",
      "e2": "/samples/Big Brass-e2.mp3",
      "e3": "/samples/Big Brass-e3.mp3",
      "e4": "/samples/Big Brass-e4.mp3",
      "e5": "/samples/Big Brass-e5.mp3",
      "f#1": "/samples/Big Brass-f#1.mp3",
      "f#2": "/samples/Big Brass-f#2.mp3",
      "f#3": "/samples/Big Brass-f#3.mp3",
      "f#4": "/samples/Big Brass-f#4.mp3",
      "f#5": "/samples/Big Brass-f#5.mp3",
      "f1": "/samples/Big Brass-f1.mp3",
      "f2": "/samples/Big Brass-f2.mp3",
      "f3": "/samples/Big Brass-f3.mp3",
      "f4": "/samples/Big Brass-f4.mp3",
      "f5": "/samples/Big Brass-f5.mp3",
      "g#1": "/samples/Big Brass-g#1.mp3",
      "g#2": "/samples/Big Brass-g#2.mp3",
      "g#3": "/samples/Big Brass-g#3.mp3",
      "g#4": "/samples/Big Brass-g#4.mp3",
      "g#5": "/samples/Big Brass-g#5.mp3",
      "g1": "/samples/Big Brass-g1.mp3",
      "g2": "/samples/Big Brass-g2.mp3",
      "g3": "/samples/Big Brass-g3.mp3",
      "g4": "/samples/Big Brass-g4.mp3",
      "g5": "/samples/Big Brass-g5.mp3"
    },
  },
  {
    id: "brighter",
    name: "Brighter",
    category: "unknown",
    samples: {
      "a#1": "/samples/Brighter-a#1.mp3",
      "a#2": "/samples/Brighter-a#2.mp3",
      "a#3": "/samples/Brighter-a#3.mp3",
      "a#4": "/samples/Brighter-a#4.mp3",
      "a#5": "/samples/Brighter-a#5.mp3",
      "a1": "/samples/Brighter-a1.mp3",
      "a2": "/samples/Brighter-a2.mp3",
      "a3": "/samples/Brighter-a3.mp3",
      "a4": "/samples/Brighter-a4.mp3",
      "a5": "/samples/Brighter-a5.mp3",
      "c#1": "/samples/Brighter-c#1.mp3",
      "c#2": "/samples/Brighter-c#2.mp3",
      "c#3": "/samples/Brighter-c#3.mp3",
      "c#4": "/samples/Brighter-c#4.mp3",
      "c#5": "/samples/Brighter-c#5.mp3",
      "c1": "/samples/Brighter-c1.mp3",
      "c2": "/samples/Brighter-c2.mp3",
      "c3": "/samples/Brighter-c3.mp3",
      "c4": "/samples/Brighter-c4.mp3",
      "c5": "/samples/Brighter-c5.mp3",
      "c6": "/samples/Brighter-c6.mp3",
      "d#1": "/samples/Brighter-d#1.mp3",
      "d#2": "/samples/Brighter-d#2.mp3",
      "d#3": "/samples/Brighter-d#3.mp3",
      "d#4": "/samples/Brighter-d#4.mp3",
      "d#5": "/samples/Brighter-d#5.mp3",
      "d1": "/samples/Brighter-d1.mp3",
      "d2": "/samples/Brighter-d2.mp3",
      "d3": "/samples/Brighter-d3.mp3",
      "d4": "/samples/Brighter-d4.mp3",
      "d5": "/samples/Brighter-d5.mp3",
      "e1": "/samples/Brighter-e1.mp3",
      "e2": "/samples/Brighter-e2.mp3",
      "e3": "/samples/Brighter-e3.mp3",
      "e4": "/samples/Brighter-e4.mp3",
      "e5": "/samples/Brighter-e5.mp3",
      "f#1": "/samples/Brighter-f#1.mp3",
      "f#2": "/samples/Brighter-f#2.mp3",
      "f#3": "/samples/Brighter-f#3.mp3",
      "f#4": "/samples/Brighter-f#4.mp3",
      "f#5": "/samples/Brighter-f#5.mp3",
      "f1": "/samples/Brighter-f1.mp3",
      "f2": "/samples/Brighter-f2.mp3",
      "f3": "/samples/Brighter-f3.mp3",
      "f4": "/samples/Brighter-f4.mp3",
      "f5": "/samples/Brighter-f5.mp3",
      "g#1": "/samples/Brighter-g#1.mp3",
      "g#2": "/samples/Brighter-g#2.mp3",
      "g#3": "/samples/Brighter-g#3.mp3",
      "g#4": "/samples/Brighter-g#4.mp3",
      "g#5": "/samples/Brighter-g#5.mp3",
      "g1": "/samples/Brighter-g1.mp3",
      "g2": "/samples/Brighter-g2.mp3",
      "g3": "/samples/Brighter-g3.mp3",
      "g4": "/samples/Brighter-g4.mp3",
      "g5": "/samples/Brighter-g5.mp3"
    },
  },
  {
    id: "crybaby",
    name: "Crybaby",
    category: "unknown",
    samples: {
      "a#1": "/samples/Crybaby-a#1.mp3",
      "a#2": "/samples/Crybaby-a#2.mp3",
      "a#3": "/samples/Crybaby-a#3.mp3",
      "a#4": "/samples/Crybaby-a#4.mp3",
      "a#5": "/samples/Crybaby-a#5.mp3",
      "a1": "/samples/Crybaby-a1.mp3",
      "a2": "/samples/Crybaby-a2.mp3",
      "a3": "/samples/Crybaby-a3.mp3",
      "a4": "/samples/Crybaby-a4.mp3",
      "a5": "/samples/Crybaby-a5.mp3",
      "c#1": "/samples/Crybaby-c#1.mp3",
      "c#2": "/samples/Crybaby-c#2.mp3",
      "c#3": "/samples/Crybaby-c#3.mp3",
      "c#4": "/samples/Crybaby-c#4.mp3",
      "c#5": "/samples/Crybaby-c#5.mp3",
      "c1": "/samples/Crybaby-c1.mp3",
      "c2": "/samples/Crybaby-c2.mp3",
      "c3": "/samples/Crybaby-c3.mp3",
      "c4": "/samples/Crybaby-c4.mp3",
      "c5": "/samples/Crybaby-c5.mp3",
      "c6": "/samples/Crybaby-c6.mp3",
      "d#1": "/samples/Crybaby-d#1.mp3",
      "d#2": "/samples/Crybaby-d#2.mp3",
      "d#3": "/samples/Crybaby-d#3.mp3",
      "d#4": "/samples/Crybaby-d#4.mp3",
      "d#5": "/samples/Crybaby-d#5.mp3",
      "d1": "/samples/Crybaby-d1.mp3",
      "d2": "/samples/Crybaby-d2.mp3",
      "d3": "/samples/Crybaby-d3.mp3",
      "d4": "/samples/Crybaby-d4.mp3",
      "d5": "/samples/Crybaby-d5.mp3",
      "e1": "/samples/Crybaby-e1.mp3",
      "e2": "/samples/Crybaby-e2.mp3",
      "e3": "/samples/Crybaby-e3.mp3",
      "e4": "/samples/Crybaby-e4.mp3",
      "e5": "/samples/Crybaby-e5.mp3",
      "f#1": "/samples/Crybaby-f#1.mp3",
      "f#2": "/samples/Crybaby-f#2.mp3",
      "f#3": "/samples/Crybaby-f#3.mp3",
      "f#4": "/samples/Crybaby-f#4.mp3",
      "f#5": "/samples/Crybaby-f#5.mp3",
      "f1": "/samples/Crybaby-f1.mp3",
      "f2": "/samples/Crybaby-f2.mp3",
      "f3": "/samples/Crybaby-f3.mp3",
      "f4": "/samples/Crybaby-f4.mp3",
      "f5": "/samples/Crybaby-f5.mp3",
      "g#1": "/samples/Crybaby-g#1.mp3",
      "g#2": "/samples/Crybaby-g#2.mp3",
      "g#3": "/samples/Crybaby-g#3.mp3",
      "g#4": "/samples/Crybaby-g#4.mp3",
      "g#5": "/samples/Crybaby-g#5.mp3",
      "g1": "/samples/Crybaby-g1.mp3",
      "g2": "/samples/Crybaby-g2.mp3",
      "g3": "/samples/Crybaby-g3.mp3",
      "g4": "/samples/Crybaby-g4.mp3",
      "g5": "/samples/Crybaby-g5.mp3"
    },
  },
  {
    id: "dot organ",
    name: "Dot organ",
    category: "unknown",
    samples: {
      "a#1": "/samples/Dot Organ-a#1.mp3",
      "a#2": "/samples/Dot Organ-a#2.mp3",
      "a#3": "/samples/Dot Organ-a#3.mp3",
      "a#4": "/samples/Dot Organ-a#4.mp3",
      "a#5": "/samples/Dot Organ-a#5.mp3",
      "a1": "/samples/Dot Organ-a1.mp3",
      "a2": "/samples/Dot Organ-a2.mp3",
      "a3": "/samples/Dot Organ-a3.mp3",
      "a4": "/samples/Dot Organ-a4.mp3",
      "a5": "/samples/Dot Organ-a5.mp3",
      "c#1": "/samples/Dot Organ-c#1.mp3",
      "c#2": "/samples/Dot Organ-c#2.mp3",
      "c#3": "/samples/Dot Organ-c#3.mp3",
      "c#4": "/samples/Dot Organ-c#4.mp3",
      "c#5": "/samples/Dot Organ-c#5.mp3",
      "c1": "/samples/Dot Organ-c1.mp3",
      "c2": "/samples/Dot Organ-c2.mp3",
      "c3": "/samples/Dot Organ-c3.mp3",
      "c4": "/samples/Dot Organ-c4.mp3",
      "c5": "/samples/Dot Organ-c5.mp3",
      "c6": "/samples/Dot Organ-c6.mp3",
      "d#1": "/samples/Dot Organ-d#1.mp3",
      "d#2": "/samples/Dot Organ-d#2.mp3",
      "d#3": "/samples/Dot Organ-d#3.mp3",
      "d#4": "/samples/Dot Organ-d#4.mp3",
      "d#5": "/samples/Dot Organ-d#5.mp3",
      "d1": "/samples/Dot Organ-d1.mp3",
      "d2": "/samples/Dot Organ-d2.mp3",
      "d3": "/samples/Dot Organ-d3.mp3",
      "d4": "/samples/Dot Organ-d4.mp3",
      "d5": "/samples/Dot Organ-d5.mp3",
      "e1": "/samples/Dot Organ-e1.mp3",
      "e2": "/samples/Dot Organ-e2.mp3",
      "e3": "/samples/Dot Organ-e3.mp3",
      "e4": "/samples/Dot Organ-e4.mp3",
      "e5": "/samples/Dot Organ-e5.mp3",
      "f#1": "/samples/Dot Organ-f#1.mp3",
      "f#2": "/samples/Dot Organ-f#2.mp3",
      "f#3": "/samples/Dot Organ-f#3.mp3",
      "f#4": "/samples/Dot Organ-f#4.mp3",
      "f#5": "/samples/Dot Organ-f#5.mp3",
      "f1": "/samples/Dot Organ-f1.mp3",
      "f2": "/samples/Dot Organ-f2.mp3",
      "f3": "/samples/Dot Organ-f3.mp3",
      "f4": "/samples/Dot Organ-f4.mp3",
      "f5": "/samples/Dot Organ-f5.mp3",
      "g#1": "/samples/Dot Organ-g#1.mp3",
      "g#2": "/samples/Dot Organ-g#2.mp3",
      "g#3": "/samples/Dot Organ-g#3.mp3",
      "g#4": "/samples/Dot Organ-g#4.mp3",
      "g#5": "/samples/Dot Organ-g#5.mp3",
      "g1": "/samples/Dot Organ-g1.mp3",
      "g2": "/samples/Dot Organ-g2.mp3",
      "g3": "/samples/Dot Organ-g3.mp3",
      "g4": "/samples/Dot Organ-g4.mp3",
      "g5": "/samples/Dot Organ-g5.mp3"
    },
  },
  {
    id: "gamer",
    name: "Gamer",
    category: "unknown",
    samples: {
      "a#1": "/samples/Gamer-a#1.mp3",
      "a#2": "/samples/Gamer-a#2.mp3",
      "a#3": "/samples/Gamer-a#3.mp3",
      "a#4": "/samples/Gamer-a#4.mp3",
      "a#5": "/samples/Gamer-a#5.mp3",
      "a1": "/samples/Gamer-a1.mp3",
      "a2": "/samples/Gamer-a2.mp3",
      "a3": "/samples/Gamer-a3.mp3",
      "a4": "/samples/Gamer-a4.mp3",
      "a5": "/samples/Gamer-a5.mp3",
      "c#1": "/samples/Gamer-c#1.mp3",
      "c#2": "/samples/Gamer-c#2.mp3",
      "c#3": "/samples/Gamer-c#3.mp3",
      "c#4": "/samples/Gamer-c#4.mp3",
      "c#5": "/samples/Gamer-c#5.mp3",
      "c1": "/samples/Gamer-c1.mp3",
      "c2": "/samples/Gamer-c2.mp3",
      "c3": "/samples/Gamer-c3.mp3",
      "c4": "/samples/Gamer-c4.mp3",
      "c5": "/samples/Gamer-c5.mp3",
      "c6": "/samples/Gamer-c6.mp3",
      "d#1": "/samples/Gamer-d#1.mp3",
      "d#2": "/samples/Gamer-d#2.mp3",
      "d#3": "/samples/Gamer-d#3.mp3",
      "d#4": "/samples/Gamer-d#4.mp3",
      "d#5": "/samples/Gamer-d#5.mp3",
      "d1": "/samples/Gamer-d1.mp3",
      "d2": "/samples/Gamer-d2.mp3",
      "d3": "/samples/Gamer-d3.mp3",
      "d4": "/samples/Gamer-d4.mp3",
      "d5": "/samples/Gamer-d5.mp3",
      "e1": "/samples/Gamer-e1.mp3",
      "e2": "/samples/Gamer-e2.mp3",
      "e3": "/samples/Gamer-e3.mp3",
      "e4": "/samples/Gamer-e4.mp3",
      "e5": "/samples/Gamer-e5.mp3",
      "f#1": "/samples/Gamer-f#1.mp3",
      "f#2": "/samples/Gamer-f#2.mp3",
      "f#3": "/samples/Gamer-f#3.mp3",
      "f#4": "/samples/Gamer-f#4.mp3",
      "f#5": "/samples/Gamer-f#5.mp3",
      "f1": "/samples/Gamer-f1.mp3",
      "f2": "/samples/Gamer-f2.mp3",
      "f3": "/samples/Gamer-f3.mp3",
      "f4": "/samples/Gamer-f4.mp3",
      "f5": "/samples/Gamer-f5.mp3",
      "g#1": "/samples/Gamer-g#1.mp3",
      "g#2": "/samples/Gamer-g#2.mp3",
      "g#3": "/samples/Gamer-g#3.mp3",
      "g#4": "/samples/Gamer-g#4.mp3",
      "g#5": "/samples/Gamer-g#5.mp3",
      "g1": "/samples/Gamer-g1.mp3",
      "g2": "/samples/Gamer-g2.mp3",
      "g3": "/samples/Gamer-g3.mp3",
      "g4": "/samples/Gamer-g4.mp3",
      "g5": "/samples/Gamer-g5.mp3"
    },
  },
  {
    id: "ghost",
    name: "Ghost",
    category: "unknown",
    samples: {
      "a#2": "/samples/Ghost-a#2.mp3",
      "a#3": "/samples/Ghost-a#3.mp3",
      "a#4": "/samples/Ghost-a#4.mp3",
      "c2": "/samples/Ghost-c2.mp3",
      "c3": "/samples/Ghost-c3.mp3",
      "c4": "/samples/Ghost-c4.mp3",
      "c5": "/samples/Ghost-c5.mp3",
      "d2": "/samples/Ghost-d2.mp3",
      "d3": "/samples/Ghost-d3.mp3",
      "d4": "/samples/Ghost-d4.mp3",
      "e2": "/samples/Ghost-e2.mp3",
      "e3": "/samples/Ghost-e3.mp3",
      "e4": "/samples/Ghost-e4.mp3",
      "f#2": "/samples/Ghost-f#2.mp3",
      "f#3": "/samples/Ghost-f#3.mp3",
      "f#4": "/samples/Ghost-f#4.mp3",
      "g#2": "/samples/Ghost-g#2.mp3",
      "g#3": "/samples/Ghost-g#3.mp3",
      "g#4": "/samples/Ghost-g#4.mp3"
    },
  },
  {
    id: "hiker",
    name: "Hiker",
    category: "unknown",
    samples: {
      "a#1": "/samples/Hiker-a#1.mp3",
      "a#2": "/samples/Hiker-a#2.mp3",
      "a#3": "/samples/Hiker-a#3.mp3",
      "a#4": "/samples/Hiker-a#4.mp3",
      "a#5": "/samples/Hiker-a#5.mp3",
      "a1": "/samples/Hiker-a1.mp3",
      "a2": "/samples/Hiker-a2.mp3",
      "a3": "/samples/Hiker-a3.mp3",
      "a4": "/samples/Hiker-a4.mp3",
      "a5": "/samples/Hiker-a5.mp3",
      "c#1": "/samples/Hiker-c#1.mp3",
      "c#2": "/samples/Hiker-c#2.mp3",
      "c#3": "/samples/Hiker-c#3.mp3",
      "c#4": "/samples/Hiker-c#4.mp3",
      "c#5": "/samples/Hiker-c#5.mp3",
      "c1": "/samples/Hiker-c1.mp3",
      "c2": "/samples/Hiker-c2.mp3",
      "c3": "/samples/Hiker-c3.mp3",
      "c4": "/samples/Hiker-c4.mp3",
      "c5": "/samples/Hiker-c5.mp3",
      "c6": "/samples/Hiker-c6.mp3",
      "d#1": "/samples/Hiker-d#1.mp3",
      "d#2": "/samples/Hiker-d#2.mp3",
      "d#3": "/samples/Hiker-d#3.mp3",
      "d#4": "/samples/Hiker-d#4.mp3",
      "d#5": "/samples/Hiker-d#5.mp3",
      "d1": "/samples/Hiker-d1.mp3",
      "d2": "/samples/Hiker-d2.mp3",
      "d3": "/samples/Hiker-d3.mp3",
      "d4": "/samples/Hiker-d4.mp3",
      "d5": "/samples/Hiker-d5.mp3",
      "e1": "/samples/Hiker-e1.mp3",
      "e2": "/samples/Hiker-e2.mp3",
      "e3": "/samples/Hiker-e3.mp3",
      "e4": "/samples/Hiker-e4.mp3",
      "e5": "/samples/Hiker-e5.mp3",
      "f#1": "/samples/Hiker-f#1.mp3",
      "f#2": "/samples/Hiker-f#2.mp3",
      "f#3": "/samples/Hiker-f#3.mp3",
      "f#4": "/samples/Hiker-f#4.mp3",
      "f#5": "/samples/Hiker-f#5.mp3",
      "f1": "/samples/Hiker-f1.mp3",
      "f2": "/samples/Hiker-f2.mp3",
      "f3": "/samples/Hiker-f3.mp3",
      "f4": "/samples/Hiker-f4.mp3",
      "f5": "/samples/Hiker-f5.mp3",
      "g#1": "/samples/Hiker-g#1.mp3",
      "g#2": "/samples/Hiker-g#2.mp3",
      "g#3": "/samples/Hiker-g#3.mp3",
      "g#4": "/samples/Hiker-g#4.mp3",
      "g#5": "/samples/Hiker-g#5.mp3",
      "g1": "/samples/Hiker-g1.mp3",
      "g2": "/samples/Hiker-g2.mp3",
      "g3": "/samples/Hiker-g3.mp3",
      "g4": "/samples/Hiker-g4.mp3",
      "g5": "/samples/Hiker-g5.mp3"
    },
  },
  {
    id: "kalimbrah",
    name: "Kalimbrah",
    category: "unknown",
    samples: {
      "a#1": "/samples/Kalimbrah-a#1.mp3",
      "a#2": "/samples/Kalimbrah-a#2.mp3",
      "a#3": "/samples/Kalimbrah-a#3.mp3",
      "a#4": "/samples/Kalimbrah-a#4.mp3",
      "a#5": "/samples/Kalimbrah-a#5.mp3",
      "a1": "/samples/Kalimbrah-a1.mp3",
      "a2": "/samples/Kalimbrah-a2.mp3",
      "a3": "/samples/Kalimbrah-a3.mp3",
      "a4": "/samples/Kalimbrah-a4.mp3",
      "a5": "/samples/Kalimbrah-a5.mp3",
      "c#1": "/samples/Kalimbrah-c#1.mp3",
      "c#2": "/samples/Kalimbrah-c#2.mp3",
      "c#3": "/samples/Kalimbrah-c#3.mp3",
      "c#4": "/samples/Kalimbrah-c#4.mp3",
      "c#5": "/samples/Kalimbrah-c#5.mp3",
      "c1": "/samples/Kalimbrah-c1.mp3",
      "c2": "/samples/Kalimbrah-c2.mp3",
      "c3": "/samples/Kalimbrah-c3.mp3",
      "c4": "/samples/Kalimbrah-c4.mp3",
      "c5": "/samples/Kalimbrah-c5.mp3",
      "c6": "/samples/Kalimbrah-c6.mp3",
      "d#1": "/samples/Kalimbrah-d#1.mp3",
      "d#2": "/samples/Kalimbrah-d#2.mp3",
      "d#3": "/samples/Kalimbrah-d#3.mp3",
      "d#4": "/samples/Kalimbrah-d#4.mp3",
      "d#5": "/samples/Kalimbrah-d#5.mp3",
      "d1": "/samples/Kalimbrah-d1.mp3",
      "d2": "/samples/Kalimbrah-d2.mp3",
      "d3": "/samples/Kalimbrah-d3.mp3",
      "d4": "/samples/Kalimbrah-d4.mp3",
      "d5": "/samples/Kalimbrah-d5.mp3",
      "e1": "/samples/Kalimbrah-e1.mp3",
      "e2": "/samples/Kalimbrah-e2.mp3",
      "e3": "/samples/Kalimbrah-e3.mp3",
      "e4": "/samples/Kalimbrah-e4.mp3",
      "e5": "/samples/Kalimbrah-e5.mp3",
      "f#1": "/samples/Kalimbrah-f#1.mp3",
      "f#2": "/samples/Kalimbrah-f#2.mp3",
      "f#3": "/samples/Kalimbrah-f#3.mp3",
      "f#4": "/samples/Kalimbrah-f#4.mp3",
      "f#5": "/samples/Kalimbrah-f#5.mp3",
      "f1": "/samples/Kalimbrah-f1.mp3",
      "f2": "/samples/Kalimbrah-f2.mp3",
      "f3": "/samples/Kalimbrah-f3.mp3",
      "f4": "/samples/Kalimbrah-f4.mp3",
      "f5": "/samples/Kalimbrah-f5.mp3",
      "g#1": "/samples/Kalimbrah-g#1.mp3",
      "g#2": "/samples/Kalimbrah-g#2.mp3",
      "g#3": "/samples/Kalimbrah-g#3.mp3",
      "g#4": "/samples/Kalimbrah-g#4.mp3",
      "g#5": "/samples/Kalimbrah-g#5.mp3",
      "g1": "/samples/Kalimbrah-g1.mp3",
      "g2": "/samples/Kalimbrah-g2.mp3",
      "g3": "/samples/Kalimbrah-g3.mp3",
      "g4": "/samples/Kalimbrah-g4.mp3",
      "g5": "/samples/Kalimbrah-g5.mp3"
    },
  },
  {
    id: "long brass",
    name: "Long brass",
    category: "unknown",
    samples: {
      "a#1": "/samples/Long Brass-a#1.mp3",
      "a#2": "/samples/Long Brass-a#2.mp3",
      "a#3": "/samples/Long Brass-a#3.mp3",
      "a#4": "/samples/Long Brass-a#4.mp3",
      "a#5": "/samples/Long Brass-a#5.mp3",
      "a1": "/samples/Long Brass-a1.mp3",
      "a2": "/samples/Long Brass-a2.mp3",
      "a3": "/samples/Long Brass-a3.mp3",
      "a4": "/samples/Long Brass-a4.mp3",
      "a5": "/samples/Long Brass-a5.mp3",
      "c#1": "/samples/Long Brass-c#1.mp3",
      "c#2": "/samples/Long Brass-c#2.mp3",
      "c#3": "/samples/Long Brass-c#3.mp3",
      "c#4": "/samples/Long Brass-c#4.mp3",
      "c#5": "/samples/Long Brass-c#5.mp3",
      "c1": "/samples/Long Brass-c1.mp3",
      "c2": "/samples/Long Brass-c2.mp3",
      "c3": "/samples/Long Brass-c3.mp3",
      "c4": "/samples/Long Brass-c4.mp3",
      "c5": "/samples/Long Brass-c5.mp3",
      "c6": "/samples/Long Brass-c6.mp3",
      "d#1": "/samples/Long Brass-d#1.mp3",
      "d#2": "/samples/Long Brass-d#2.mp3",
      "d#3": "/samples/Long Brass-d#3.mp3",
      "d#4": "/samples/Long Brass-d#4.mp3",
      "d#5": "/samples/Long Brass-d#5.mp3",
      "d1": "/samples/Long Brass-d1.mp3",
      "d2": "/samples/Long Brass-d2.mp3",
      "d3": "/samples/Long Brass-d3.mp3",
      "d4": "/samples/Long Brass-d4.mp3",
      "d5": "/samples/Long Brass-d5.mp3",
      "e1": "/samples/Long Brass-e1.mp3",
      "e2": "/samples/Long Brass-e2.mp3",
      "e3": "/samples/Long Brass-e3.mp3",
      "e4": "/samples/Long Brass-e4.mp3",
      "e5": "/samples/Long Brass-e5.mp3",
      "f#1": "/samples/Long Brass-f#1.mp3",
      "f#2": "/samples/Long Brass-f#2.mp3",
      "f#3": "/samples/Long Brass-f#3.mp3",
      "f#4": "/samples/Long Brass-f#4.mp3",
      "f#5": "/samples/Long Brass-f#5.mp3",
      "f1": "/samples/Long Brass-f1.mp3",
      "f2": "/samples/Long Brass-f2.mp3",
      "f3": "/samples/Long Brass-f3.mp3",
      "f4": "/samples/Long Brass-f4.mp3",
      "f5": "/samples/Long Brass-f5.mp3",
      "g#1": "/samples/Long Brass-g#1.mp3",
      "g#2": "/samples/Long Brass-g#2.mp3",
      "g#3": "/samples/Long Brass-g#3.mp3",
      "g#4": "/samples/Long Brass-g#4.mp3",
      "g#5": "/samples/Long Brass-g#5.mp3",
      "g1": "/samples/Long Brass-g1.mp3",
      "g2": "/samples/Long Brass-g2.mp3",
      "g3": "/samples/Long Brass-g3.mp3",
      "g4": "/samples/Long Brass-g4.mp3",
      "g5": "/samples/Long Brass-g5.mp3"
    },
  },
  {
    id: "mellowman",
    name: "Mellowman",
    category: "unknown",
    samples: {
      "a#1": "/samples/Mellowman-a#1.mp3",
      "a#2": "/samples/Mellowman-a#2.mp3",
      "a#3": "/samples/Mellowman-a#3.mp3",
      "a#4": "/samples/Mellowman-a#4.mp3",
      "a#5": "/samples/Mellowman-a#5.mp3",
      "a1": "/samples/Mellowman-a1.mp3",
      "a2": "/samples/Mellowman-a2.mp3",
      "a3": "/samples/Mellowman-a3.mp3",
      "a4": "/samples/Mellowman-a4.mp3",
      "a5": "/samples/Mellowman-a5.mp3",
      "c#1": "/samples/Mellowman-c#1.mp3",
      "c#2": "/samples/Mellowman-c#2.mp3",
      "c#3": "/samples/Mellowman-c#3.mp3",
      "c#4": "/samples/Mellowman-c#4.mp3",
      "c#5": "/samples/Mellowman-c#5.mp3",
      "c1": "/samples/Mellowman-c1.mp3",
      "c2": "/samples/Mellowman-c2.mp3",
      "c3": "/samples/Mellowman-c3.mp3",
      "c4": "/samples/Mellowman-c4.mp3",
      "c5": "/samples/Mellowman-c5.mp3",
      "c6": "/samples/Mellowman-c6.mp3",
      "d#1": "/samples/Mellowman-d#1.mp3",
      "d#2": "/samples/Mellowman-d#2.mp3",
      "d#3": "/samples/Mellowman-d#3.mp3",
      "d#4": "/samples/Mellowman-d#4.mp3",
      "d#5": "/samples/Mellowman-d#5.mp3",
      "d1": "/samples/Mellowman-d1.mp3",
      "d2": "/samples/Mellowman-d2.mp3",
      "d3": "/samples/Mellowman-d3.mp3",
      "d4": "/samples/Mellowman-d4.mp3",
      "d5": "/samples/Mellowman-d5.mp3",
      "e1": "/samples/Mellowman-e1.mp3",
      "e2": "/samples/Mellowman-e2.mp3",
      "e3": "/samples/Mellowman-e3.mp3",
      "e4": "/samples/Mellowman-e4.mp3",
      "e5": "/samples/Mellowman-e5.mp3",
      "f#1": "/samples/Mellowman-f#1.mp3",
      "f#2": "/samples/Mellowman-f#2.mp3",
      "f#3": "/samples/Mellowman-f#3.mp3",
      "f#4": "/samples/Mellowman-f#4.mp3",
      "f#5": "/samples/Mellowman-f#5.mp3",
      "f1": "/samples/Mellowman-f1.mp3",
      "f2": "/samples/Mellowman-f2.mp3",
      "f3": "/samples/Mellowman-f3.mp3",
      "f4": "/samples/Mellowman-f4.mp3",
      "f5": "/samples/Mellowman-f5.mp3",
      "g#1": "/samples/Mellowman-g#1.mp3",
      "g#2": "/samples/Mellowman-g#2.mp3",
      "g#3": "/samples/Mellowman-g#3.mp3",
      "g#4": "/samples/Mellowman-g#4.mp3",
      "g#5": "/samples/Mellowman-g#5.mp3",
      "g1": "/samples/Mellowman-g1.mp3",
      "g2": "/samples/Mellowman-g2.mp3",
      "g3": "/samples/Mellowman-g3.mp3",
      "g4": "/samples/Mellowman-g4.mp3",
      "g5": "/samples/Mellowman-g5.mp3"
    },
  },
  {
    id: "metallo",
    name: "Metallo",
    category: "metallic",
    samples: {
      "a#2": "/samples/Metallo-a#2.mp3",
      "a#3": "/samples/Metallo-a#3.mp3",
      "a#4": "/samples/Metallo-a#4.mp3",
      "c2": "/samples/Metallo-c2.mp3",
      "c3": "/samples/Metallo-c3.mp3",
      "c4": "/samples/Metallo-c4.mp3",
      "c5": "/samples/Metallo-c5.mp3",
      "d2": "/samples/Metallo-d2.mp3",
      "d3": "/samples/Metallo-d3.mp3",
      "d4": "/samples/Metallo-d4.mp3",
      "e2": "/samples/Metallo-e2.mp3",
      "e3": "/samples/Metallo-e3.mp3",
      "e4": "/samples/Metallo-e4.mp3",
      "f#2": "/samples/Metallo-f#2.mp3",
      "f#3": "/samples/Metallo-f#3.mp3",
      "f#4": "/samples/Metallo-f#4.mp3",
      "g#2": "/samples/Metallo-g#2.mp3",
      "g#3": "/samples/Metallo-g#3.mp3",
      "g#4": "/samples/Metallo-g#4.mp3"
    },
  },
  {
    id: "most curious",
    name: "Most curious",
    category: "unknown",
    samples: {
      "a#1": "/samples/Most Curious-a#1.mp3",
      "a#2": "/samples/Most Curious-a#2.mp3",
      "a#3": "/samples/Most Curious-a#3.mp3",
      "a#4": "/samples/Most Curious-a#4.mp3",
      "a#5": "/samples/Most Curious-a#5.mp3",
      "a1": "/samples/Most Curious-a1.mp3",
      "a2": "/samples/Most Curious-a2.mp3",
      "a3": "/samples/Most Curious-a3.mp3",
      "a4": "/samples/Most Curious-a4.mp3",
      "a5": "/samples/Most Curious-a5.mp3",
      "c#1": "/samples/Most Curious-c#1.mp3",
      "c#2": "/samples/Most Curious-c#2.mp3",
      "c#3": "/samples/Most Curious-c#3.mp3",
      "c#4": "/samples/Most Curious-c#4.mp3",
      "c#5": "/samples/Most Curious-c#5.mp3",
      "c1": "/samples/Most Curious-c1.mp3",
      "c2": "/samples/Most Curious-c2.mp3",
      "c3": "/samples/Most Curious-c3.mp3",
      "c4": "/samples/Most Curious-c4.mp3",
      "c5": "/samples/Most Curious-c5.mp3",
      "c6": "/samples/Most Curious-c6.mp3",
      "d#1": "/samples/Most Curious-d#1.mp3",
      "d#2": "/samples/Most Curious-d#2.mp3",
      "d#3": "/samples/Most Curious-d#3.mp3",
      "d#4": "/samples/Most Curious-d#4.mp3",
      "d#5": "/samples/Most Curious-d#5.mp3",
      "d1": "/samples/Most Curious-d1.mp3",
      "d2": "/samples/Most Curious-d2.mp3",
      "d3": "/samples/Most Curious-d3.mp3",
      "d4": "/samples/Most Curious-d4.mp3",
      "d5": "/samples/Most Curious-d5.mp3",
      "e1": "/samples/Most Curious-e1.mp3",
      "e2": "/samples/Most Curious-e2.mp3",
      "e3": "/samples/Most Curious-e3.mp3",
      "e4": "/samples/Most Curious-e4.mp3",
      "e5": "/samples/Most Curious-e5.mp3",
      "f#1": "/samples/Most Curious-f#1.mp3",
      "f#2": "/samples/Most Curious-f#2.mp3",
      "f#3": "/samples/Most Curious-f#3.mp3",
      "f#4": "/samples/Most Curious-f#4.mp3",
      "f#5": "/samples/Most Curious-f#5.mp3",
      "f1": "/samples/Most Curious-f1.mp3",
      "f2": "/samples/Most Curious-f2.mp3",
      "f3": "/samples/Most Curious-f3.mp3",
      "f4": "/samples/Most Curious-f4.mp3",
      "f5": "/samples/Most Curious-f5.mp3",
      "g#1": "/samples/Most Curious-g#1.mp3",
      "g#2": "/samples/Most Curious-g#2.mp3",
      "g#3": "/samples/Most Curious-g#3.mp3",
      "g#4": "/samples/Most Curious-g#4.mp3",
      "g#5": "/samples/Most Curious-g#5.mp3",
      "g1": "/samples/Most Curious-g1.mp3",
      "g2": "/samples/Most Curious-g2.mp3",
      "g3": "/samples/Most Curious-g3.mp3",
      "g4": "/samples/Most Curious-g4.mp3",
      "g5": "/samples/Most Curious-g5.mp3"
    },
  },
  {
    id: "pretty",
    name: "Pretty",
    category: "unknown",
    samples: {
      "a#1": "/samples/Pretty-a#1.mp3",
      "a#2": "/samples/Pretty-a#2.mp3",
      "a#3": "/samples/Pretty-a#3.mp3",
      "a#4": "/samples/Pretty-a#4.mp3",
      "a#5": "/samples/Pretty-a#5.mp3",
      "a1": "/samples/Pretty-a1.mp3",
      "a2": "/samples/Pretty-a2.mp3",
      "a3": "/samples/Pretty-a3.mp3",
      "a4": "/samples/Pretty-a4.mp3",
      "a5": "/samples/Pretty-a5.mp3",
      "c#1": "/samples/Pretty-c#1.mp3",
      "c#2": "/samples/Pretty-c#2.mp3",
      "c#3": "/samples/Pretty-c#3.mp3",
      "c#4": "/samples/Pretty-c#4.mp3",
      "c#5": "/samples/Pretty-c#5.mp3",
      "c1": "/samples/Pretty-c1.mp3",
      "c2": "/samples/Pretty-c2.mp3",
      "c3": "/samples/Pretty-c3.mp3",
      "c4": "/samples/Pretty-c4.mp3",
      "c5": "/samples/Pretty-c5.mp3",
      "c6": "/samples/Pretty-c6.mp3",
      "d#1": "/samples/Pretty-d#1.mp3",
      "d#2": "/samples/Pretty-d#2.mp3",
      "d#3": "/samples/Pretty-d#3.mp3",
      "d#4": "/samples/Pretty-d#4.mp3",
      "d#5": "/samples/Pretty-d#5.mp3",
      "d1": "/samples/Pretty-d1.mp3",
      "d2": "/samples/Pretty-d2.mp3",
      "d3": "/samples/Pretty-d3.mp3",
      "d4": "/samples/Pretty-d4.mp3",
      "d5": "/samples/Pretty-d5.mp3",
      "e1": "/samples/Pretty-e1.mp3",
      "e2": "/samples/Pretty-e2.mp3",
      "e3": "/samples/Pretty-e3.mp3",
      "e4": "/samples/Pretty-e4.mp3",
      "e5": "/samples/Pretty-e5.mp3",
      "f#1": "/samples/Pretty-f#1.mp3",
      "f#2": "/samples/Pretty-f#2.mp3",
      "f#3": "/samples/Pretty-f#3.mp3",
      "f#4": "/samples/Pretty-f#4.mp3",
      "f#5": "/samples/Pretty-f#5.mp3",
      "f1": "/samples/Pretty-f1.mp3",
      "f2": "/samples/Pretty-f2.mp3",
      "f3": "/samples/Pretty-f3.mp3",
      "f4": "/samples/Pretty-f4.mp3",
      "f5": "/samples/Pretty-f5.mp3",
      "g#1": "/samples/Pretty-g#1.mp3",
      "g#2": "/samples/Pretty-g#2.mp3",
      "g#3": "/samples/Pretty-g#3.mp3",
      "g#4": "/samples/Pretty-g#4.mp3",
      "g#5": "/samples/Pretty-g#5.mp3",
      "g1": "/samples/Pretty-g1.mp3",
      "g2": "/samples/Pretty-g2.mp3",
      "g3": "/samples/Pretty-g3.mp3",
      "g4": "/samples/Pretty-g4.mp3",
      "g5": "/samples/Pretty-g5.mp3"
    },
  },
  {
    id: "prosaw",
    name: "Prosaw",
    category: "distorted",
    samples: {
      "a#2": "/samples/ProSaw-a#2.mp3",
      "a#3": "/samples/ProSaw-a#3.mp3",
      "a#4": "/samples/ProSaw-a#4.mp3",
      "a2": "/samples/ProSaw-a2.mp3",
      "a3": "/samples/ProSaw-a3.mp3",
      "a4": "/samples/ProSaw-a4.mp3",
      "c#2": "/samples/ProSaw-c#2.mp3",
      "c#3": "/samples/ProSaw-c#3.mp3",
      "c#4": "/samples/ProSaw-c#4.mp3",
      "c2": "/samples/ProSaw-c2.mp3",
      "c3": "/samples/ProSaw-c3.mp3",
      "c4": "/samples/ProSaw-c4.mp3",
      "c5": "/samples/ProSaw-c5.mp3",
      "d#2": "/samples/ProSaw-d#2.mp3",
      "d#3": "/samples/ProSaw-d#3.mp3",
      "d#4": "/samples/ProSaw-d#4.mp3",
      "d2": "/samples/ProSaw-d2.mp3",
      "d3": "/samples/ProSaw-d3.mp3",
      "d4": "/samples/ProSaw-d4.mp3",
      "e2": "/samples/ProSaw-e2.mp3",
      "e3": "/samples/ProSaw-e3.mp3",
      "e4": "/samples/ProSaw-e4.mp3",
      "f#2": "/samples/ProSaw-f#2.mp3",
      "f#3": "/samples/ProSaw-f#3.mp3",
      "f#4": "/samples/ProSaw-f#4.mp3",
      "f2": "/samples/ProSaw-f2.mp3",
      "f3": "/samples/ProSaw-f3.mp3",
      "f4": "/samples/ProSaw-f4.mp3",
      "g#2": "/samples/ProSaw-g#2.mp3",
      "g#3": "/samples/ProSaw-g#3.mp3",
      "g#4": "/samples/ProSaw-g#4.mp3",
      "g2": "/samples/ProSaw-g2.mp3",
      "g3": "/samples/ProSaw-g3.mp3",
      "g4": "/samples/ProSaw-g4.mp3"
    },
  },
  {
    id: "side door",
    name: "Side door",
    category: "unknown",
    samples: {
      "a#1": "/samples/Side Door-a#1.mp3",
      "a#2": "/samples/Side Door-a#2.mp3",
      "a#3": "/samples/Side Door-a#3.mp3",
      "a#4": "/samples/Side Door-a#4.mp3",
      "a#5": "/samples/Side Door-a#5.mp3",
      "a1": "/samples/Side Door-a1.mp3",
      "a2": "/samples/Side Door-a2.mp3",
      "a3": "/samples/Side Door-a3.mp3",
      "a4": "/samples/Side Door-a4.mp3",
      "a5": "/samples/Side Door-a5.mp3",
      "c#1": "/samples/Side Door-c#1.mp3",
      "c#2": "/samples/Side Door-c#2.mp3",
      "c#3": "/samples/Side Door-c#3.mp3",
      "c#4": "/samples/Side Door-c#4.mp3",
      "c#5": "/samples/Side Door-c#5.mp3",
      "c1": "/samples/Side Door-c1.mp3",
      "c2": "/samples/Side Door-c2.mp3",
      "c3": "/samples/Side Door-c3.mp3",
      "c4": "/samples/Side Door-c4.mp3",
      "c5": "/samples/Side Door-c5.mp3",
      "c6": "/samples/Side Door-c6.mp3",
      "d#1": "/samples/Side Door-d#1.mp3",
      "d#2": "/samples/Side Door-d#2.mp3",
      "d#3": "/samples/Side Door-d#3.mp3",
      "d#4": "/samples/Side Door-d#4.mp3",
      "d#5": "/samples/Side Door-d#5.mp3",
      "d1": "/samples/Side Door-d1.mp3",
      "d2": "/samples/Side Door-d2.mp3",
      "d3": "/samples/Side Door-d3.mp3",
      "d4": "/samples/Side Door-d4.mp3",
      "d5": "/samples/Side Door-d5.mp3",
      "e1": "/samples/Side Door-e1.mp3",
      "e2": "/samples/Side Door-e2.mp3",
      "e3": "/samples/Side Door-e3.mp3",
      "e4": "/samples/Side Door-e4.mp3",
      "e5": "/samples/Side Door-e5.mp3",
      "f#1": "/samples/Side Door-f#1.mp3",
      "f#2": "/samples/Side Door-f#2.mp3",
      "f#3": "/samples/Side Door-f#3.mp3",
      "f#4": "/samples/Side Door-f#4.mp3",
      "f#5": "/samples/Side Door-f#5.mp3",
      "f1": "/samples/Side Door-f1.mp3",
      "f2": "/samples/Side Door-f2.mp3",
      "f3": "/samples/Side Door-f3.mp3",
      "f4": "/samples/Side Door-f4.mp3",
      "f5": "/samples/Side Door-f5.mp3",
      "g#1": "/samples/Side Door-g#1.mp3",
      "g#2": "/samples/Side Door-g#2.mp3",
      "g#3": "/samples/Side Door-g#3.mp3",
      "g#4": "/samples/Side Door-g#4.mp3",
      "g#5": "/samples/Side Door-g#5.mp3",
      "g1": "/samples/Side Door-g1.mp3",
      "g2": "/samples/Side Door-g2.mp3",
      "g3": "/samples/Side Door-g3.mp3",
      "g4": "/samples/Side Door-g4.mp3",
      "g5": "/samples/Side Door-g5.mp3"
    },
  },
  {
    id: "sonder",
    name: "Sonder",
    category: "unknown",
    samples: {
      "a#1": "/samples/Sonder-a#1.mp3",
      "a#2": "/samples/Sonder-a#2.mp3",
      "a#3": "/samples/Sonder-a#3.mp3",
      "a#4": "/samples/Sonder-a#4.mp3",
      "a#5": "/samples/Sonder-a#5.mp3",
      "a1": "/samples/Sonder-a1.mp3",
      "a2": "/samples/Sonder-a2.mp3",
      "a3": "/samples/Sonder-a3.mp3",
      "a4": "/samples/Sonder-a4.mp3",
      "a5": "/samples/Sonder-a5.mp3",
      "c#1": "/samples/Sonder-c#1.mp3",
      "c#2": "/samples/Sonder-c#2.mp3",
      "c#3": "/samples/Sonder-c#3.mp3",
      "c#4": "/samples/Sonder-c#4.mp3",
      "c#5": "/samples/Sonder-c#5.mp3",
      "c1": "/samples/Sonder-c1.mp3",
      "c2": "/samples/Sonder-c2.mp3",
      "c3": "/samples/Sonder-c3.mp3",
      "c4": "/samples/Sonder-c4.mp3",
      "c5": "/samples/Sonder-c5.mp3",
      "c6": "/samples/Sonder-c6.mp3",
      "d#1": "/samples/Sonder-d#1.mp3",
      "d#2": "/samples/Sonder-d#2.mp3",
      "d#3": "/samples/Sonder-d#3.mp3",
      "d#4": "/samples/Sonder-d#4.mp3",
      "d#5": "/samples/Sonder-d#5.mp3",
      "d1": "/samples/Sonder-d1.mp3",
      "d2": "/samples/Sonder-d2.mp3",
      "d3": "/samples/Sonder-d3.mp3",
      "d4": "/samples/Sonder-d4.mp3",
      "d5": "/samples/Sonder-d5.mp3",
      "e1": "/samples/Sonder-e1.mp3",
      "e2": "/samples/Sonder-e2.mp3",
      "e3": "/samples/Sonder-e3.mp3",
      "e4": "/samples/Sonder-e4.mp3",
      "e5": "/samples/Sonder-e5.mp3",
      "f#1": "/samples/Sonder-f#1.mp3",
      "f#2": "/samples/Sonder-f#2.mp3",
      "f#3": "/samples/Sonder-f#3.mp3",
      "f#4": "/samples/Sonder-f#4.mp3",
      "f#5": "/samples/Sonder-f#5.mp3",
      "f1": "/samples/Sonder-f1.mp3",
      "f2": "/samples/Sonder-f2.mp3",
      "f3": "/samples/Sonder-f3.mp3",
      "f4": "/samples/Sonder-f4.mp3",
      "f5": "/samples/Sonder-f5.mp3",
      "g#1": "/samples/Sonder-g#1.mp3",
      "g#2": "/samples/Sonder-g#2.mp3",
      "g#3": "/samples/Sonder-g#3.mp3",
      "g#4": "/samples/Sonder-g#4.mp3",
      "g#5": "/samples/Sonder-g#5.mp3",
      "g1": "/samples/Sonder-g1.mp3",
      "g2": "/samples/Sonder-g2.mp3",
      "g3": "/samples/Sonder-g3.mp3",
      "g4": "/samples/Sonder-g4.mp3",
      "g5": "/samples/Sonder-g5.mp3"
    },
  },
  {
    id: "stardom",
    name: "Stardom",
    category: "unknown",
    samples: {
      "a#1": "/samples/Stardom-a#1.mp3",
      "a#2": "/samples/Stardom-a#2.mp3",
      "a#3": "/samples/Stardom-a#3.mp3",
      "a#4": "/samples/Stardom-a#4.mp3",
      "a#5": "/samples/Stardom-a#5.mp3",
      "a1": "/samples/Stardom-a1.mp3",
      "a2": "/samples/Stardom-a2.mp3",
      "a3": "/samples/Stardom-a3.mp3",
      "a4": "/samples/Stardom-a4.mp3",
      "a5": "/samples/Stardom-a5.mp3",
      "c#1": "/samples/Stardom-c#1.mp3",
      "c#2": "/samples/Stardom-c#2.mp3",
      "c#3": "/samples/Stardom-c#3.mp3",
      "c#4": "/samples/Stardom-c#4.mp3",
      "c#5": "/samples/Stardom-c#5.mp3",
      "c1": "/samples/Stardom-c1.mp3",
      "c2": "/samples/Stardom-c2.mp3",
      "c3": "/samples/Stardom-c3.mp3",
      "c4": "/samples/Stardom-c4.mp3",
      "c5": "/samples/Stardom-c5.mp3",
      "c6": "/samples/Stardom-c6.mp3",
      "d#1": "/samples/Stardom-d#1.mp3",
      "d#2": "/samples/Stardom-d#2.mp3",
      "d#3": "/samples/Stardom-d#3.mp3",
      "d#4": "/samples/Stardom-d#4.mp3",
      "d#5": "/samples/Stardom-d#5.mp3",
      "d1": "/samples/Stardom-d1.mp3",
      "d2": "/samples/Stardom-d2.mp3",
      "d3": "/samples/Stardom-d3.mp3",
      "d4": "/samples/Stardom-d4.mp3",
      "d5": "/samples/Stardom-d5.mp3",
      "e1": "/samples/Stardom-e1.mp3",
      "e2": "/samples/Stardom-e2.mp3",
      "e3": "/samples/Stardom-e3.mp3",
      "e4": "/samples/Stardom-e4.mp3",
      "e5": "/samples/Stardom-e5.mp3",
      "f#1": "/samples/Stardom-f#1.mp3",
      "f#2": "/samples/Stardom-f#2.mp3",
      "f#3": "/samples/Stardom-f#3.mp3",
      "f#4": "/samples/Stardom-f#4.mp3",
      "f#5": "/samples/Stardom-f#5.mp3",
      "f1": "/samples/Stardom-f1.mp3",
      "f2": "/samples/Stardom-f2.mp3",
      "f3": "/samples/Stardom-f3.mp3",
      "f4": "/samples/Stardom-f4.mp3",
      "f5": "/samples/Stardom-f5.mp3",
      "g#1": "/samples/Stardom-g#1.mp3",
      "g#2": "/samples/Stardom-g#2.mp3",
      "g#3": "/samples/Stardom-g#3.mp3",
      "g#4": "/samples/Stardom-g#4.mp3",
      "g#5": "/samples/Stardom-g#5.mp3",
      "g1": "/samples/Stardom-g1.mp3",
      "g2": "/samples/Stardom-g2.mp3",
      "g3": "/samples/Stardom-g3.mp3",
      "g4": "/samples/Stardom-g4.mp3",
      "g5": "/samples/Stardom-g5.mp3"
    },
  },
  {
    id: "unchoir",
    name: "Unchoir",
    category: "unknown",
    samples: {
      "a#1": "/samples/UnChoir-a#1.mp3",
      "a#2": "/samples/UnChoir-a#2.mp3",
      "a#3": "/samples/UnChoir-a#3.mp3",
      "a#4": "/samples/UnChoir-a#4.mp3",
      "a#5": "/samples/UnChoir-a#5.mp3",
      "a1": "/samples/UnChoir-a1.mp3",
      "a2": "/samples/UnChoir-a2.mp3",
      "a3": "/samples/UnChoir-a3.mp3",
      "a4": "/samples/UnChoir-a4.mp3",
      "a5": "/samples/UnChoir-a5.mp3",
      "c#1": "/samples/UnChoir-c#1.mp3",
      "c#2": "/samples/UnChoir-c#2.mp3",
      "c#3": "/samples/UnChoir-c#3.mp3",
      "c#4": "/samples/UnChoir-c#4.mp3",
      "c#5": "/samples/UnChoir-c#5.mp3",
      "c1": "/samples/UnChoir-c1.mp3",
      "c2": "/samples/UnChoir-c2.mp3",
      "c3": "/samples/UnChoir-c3.mp3",
      "c4": "/samples/UnChoir-c4.mp3",
      "c5": "/samples/UnChoir-c5.mp3",
      "c6": "/samples/UnChoir-c6.mp3",
      "d#1": "/samples/UnChoir-d#1.mp3",
      "d#2": "/samples/UnChoir-d#2.mp3",
      "d#3": "/samples/UnChoir-d#3.mp3",
      "d#4": "/samples/UnChoir-d#4.mp3",
      "d#5": "/samples/UnChoir-d#5.mp3",
      "d1": "/samples/UnChoir-d1.mp3",
      "d2": "/samples/UnChoir-d2.mp3",
      "d3": "/samples/UnChoir-d3.mp3",
      "d4": "/samples/UnChoir-d4.mp3",
      "d5": "/samples/UnChoir-d5.mp3",
      "e1": "/samples/UnChoir-e1.mp3",
      "e2": "/samples/UnChoir-e2.mp3",
      "e3": "/samples/UnChoir-e3.mp3",
      "e4": "/samples/UnChoir-e4.mp3",
      "e5": "/samples/UnChoir-e5.mp3",
      "f#1": "/samples/UnChoir-f#1.mp3",
      "f#2": "/samples/UnChoir-f#2.mp3",
      "f#3": "/samples/UnChoir-f#3.mp3",
      "f#4": "/samples/UnChoir-f#4.mp3",
      "f#5": "/samples/UnChoir-f#5.mp3",
      "f1": "/samples/UnChoir-f1.mp3",
      "f2": "/samples/UnChoir-f2.mp3",
      "f3": "/samples/UnChoir-f3.mp3",
      "f4": "/samples/UnChoir-f4.mp3",
      "f5": "/samples/UnChoir-f5.mp3",
      "g#1": "/samples/UnChoir-g#1.mp3",
      "g#2": "/samples/UnChoir-g#2.mp3",
      "g#3": "/samples/UnChoir-g#3.mp3",
      "g#4": "/samples/UnChoir-g#4.mp3",
      "g#5": "/samples/UnChoir-g#5.mp3",
      "g1": "/samples/UnChoir-g1.mp3",
      "g2": "/samples/UnChoir-g2.mp3",
      "g3": "/samples/UnChoir-g3.mp3",
      "g4": "/samples/UnChoir-g4.mp3",
      "g5": "/samples/UnChoir-g5.mp3"
    },
  },
  {
    id: "hello_dance",
    name: "Hello_dance",
    category: "unknown",
    samples: {
      "a#2": "/samples/hello_dance-a#2.mp3",
      "a#3": "/samples/hello_dance-a#3.mp3",
      "a#4": "/samples/hello_dance-a#4.mp3",
      "a2": "/samples/hello_dance-a2.mp3",
      "a3": "/samples/hello_dance-a3.mp3",
      "a4": "/samples/hello_dance-a4.mp3",
      "c#2": "/samples/hello_dance-c#2.mp3",
      "c#3": "/samples/hello_dance-c#3.mp3",
      "c#4": "/samples/hello_dance-c#4.mp3",
      "c2": "/samples/hello_dance-c2.mp3",
      "c3": "/samples/hello_dance-c3.mp3",
      "c4": "/samples/hello_dance-c4.mp3",
      "c5": "/samples/hello_dance-c5.mp3",
      "d#2": "/samples/hello_dance-d#2.mp3",
      "d#3": "/samples/hello_dance-d#3.mp3",
      "d#4": "/samples/hello_dance-d#4.mp3",
      "d2": "/samples/hello_dance-d2.mp3",
      "d3": "/samples/hello_dance-d3.mp3",
      "d4": "/samples/hello_dance-d4.mp3",
      "e2": "/samples/hello_dance-e2.mp3",
      "e3": "/samples/hello_dance-e3.mp3",
      "e4": "/samples/hello_dance-e4.mp3",
      "f#2": "/samples/hello_dance-f#2.mp3",
      "f#3": "/samples/hello_dance-f#3.mp3",
      "f#4": "/samples/hello_dance-f#4.mp3",
      "f2": "/samples/hello_dance-f2.mp3",
      "f3": "/samples/hello_dance-f3.mp3",
      "f4": "/samples/hello_dance-f4.mp3",
      "g#2": "/samples/hello_dance-g#2.mp3",
      "g#3": "/samples/hello_dance-g#3.mp3",
      "g#4": "/samples/hello_dance-g#4.mp3",
      "g2": "/samples/hello_dance-g2.mp3",
      "g3": "/samples/hello_dance-g3.mp3",
      "g4": "/samples/hello_dance-g4.mp3"
    },
  },
  {
    id: "plucking",
    name: "Plucking",
    category: "unknown",
    samples: {
      "a#2": "/samples/plucking-a#2.mp3",
      "a#3": "/samples/plucking-a#3.mp3",
      "a#4": "/samples/plucking-a#4.mp3",
      "a2": "/samples/plucking-a2.mp3",
      "a3": "/samples/plucking-a3.mp3",
      "a4": "/samples/plucking-a4.mp3",
      "c#2": "/samples/plucking-c#2.mp3",
      "c#3": "/samples/plucking-c#3.mp3",
      "c#4": "/samples/plucking-c#4.mp3",
      "c2": "/samples/plucking-c2.mp3",
      "c3": "/samples/plucking-c3.mp3",
      "c4": "/samples/plucking-c4.mp3",
      "c5": "/samples/plucking-c5.mp3",
      "d#2": "/samples/plucking-d#2.mp3",
      "d#3": "/samples/plucking-d#3.mp3",
      "d#4": "/samples/plucking-d#4.mp3",
      "d2": "/samples/plucking-d2.mp3",
      "d3": "/samples/plucking-d3.mp3",
      "d4": "/samples/plucking-d4.mp3",
      "e2": "/samples/plucking-e2.mp3",
      "e3": "/samples/plucking-e3.mp3",
      "e4": "/samples/plucking-e4.mp3",
      "f#2": "/samples/plucking-f#2.mp3",
      "f#3": "/samples/plucking-f#3.mp3",
      "f#4": "/samples/plucking-f#4.mp3",
      "f2": "/samples/plucking-f2.mp3",
      "f3": "/samples/plucking-f3.mp3",
      "f4": "/samples/plucking-f4.mp3",
      "g#2": "/samples/plucking-g#2.mp3",
      "g#3": "/samples/plucking-g#3.mp3",
      "g#4": "/samples/plucking-g#4.mp3",
      "g2": "/samples/plucking-g2.mp3",
      "g3": "/samples/plucking-g3.mp3",
      "g4": "/samples/plucking-g4.mp3"
    },
  },
  {
    id: "soft_pad",
    name: "Soft_pad",
    category: "unknown",
    samples: {
      "a#2": "/samples/soft_pad-a#2.mp3",
      "a#3": "/samples/soft_pad-a#3.mp3",
      "a#4": "/samples/soft_pad-a#4.mp3",
      "a2": "/samples/soft_pad-a2.mp3",
      "a3": "/samples/soft_pad-a3.mp3",
      "a4": "/samples/soft_pad-a4.mp3",
      "c#2": "/samples/soft_pad-c#2.mp3",
      "c#3": "/samples/soft_pad-c#3.mp3",
      "c#4": "/samples/soft_pad-c#4.mp3",
      "c2": "/samples/soft_pad-c2.mp3",
      "c3": "/samples/soft_pad-c3.mp3",
      "c4": "/samples/soft_pad-c4.mp3",
      "c5": "/samples/soft_pad-c5.mp3",
      "d#2": "/samples/soft_pad-d#2.mp3",
      "d#3": "/samples/soft_pad-d#3.mp3",
      "d#4": "/samples/soft_pad-d#4.mp3",
      "d2": "/samples/soft_pad-d2.mp3",
      "d3": "/samples/soft_pad-d3.mp3",
      "d4": "/samples/soft_pad-d4.mp3",
      "e2": "/samples/soft_pad-e2.mp3",
      "e3": "/samples/soft_pad-e3.mp3",
      "e4": "/samples/soft_pad-e4.mp3",
      "f#2": "/samples/soft_pad-f#2.mp3",
      "f#3": "/samples/soft_pad-f#3.mp3",
      "f#4": "/samples/soft_pad-f#4.mp3",
      "f2": "/samples/soft_pad-f2.mp3",
      "f3": "/samples/soft_pad-f3.mp3",
      "f4": "/samples/soft_pad-f4.mp3",
      "g#2": "/samples/soft_pad-g#2.mp3",
      "g#3": "/samples/soft_pad-g#3.mp3",
      "g#4": "/samples/soft_pad-g#4.mp3",
      "g2": "/samples/soft_pad-g2.mp3",
      "g3": "/samples/soft_pad-g3.mp3",
      "g4": "/samples/soft_pad-g4.mp3"
    },
  },
];

// Get a multi-key instrument by ID
export const getMultiKeyInstrumentById = (
  id: string
): MultiKeyInstrument | null => {
  return (
    MULTI_KEY_INSTRUMENTS.find((instrument) => instrument.id === id) || null
  );
};

// Get all available instruments
export const getAllInstruments = () => {
  return MULTI_KEY_INSTRUMENTS.map((instrument) => ({
    id: instrument.id,
    name: instrument.name,
    type: "multi-key" as const,
    category: instrument.category,
  }));
};

// Get default instrument (first one)
export const getDefaultInstrument = (): MultiKeyInstrument => {
  return MULTI_KEY_INSTRUMENTS[0];
};

// Custom instruments storage (for uploaded samples)
const CUSTOM_INSTRUMENTS: {
  [id: string]: {
    instrument: MultiKeyInstrument;
    player: any;
  };
} = {};

const normalizeSampleUrl = (url: string): string => {
  return url.startsWith("blob:") ? url : url.replace(/#/g, "%23");
};

/**
 * Registers a custom instrument with its player
 * @param instrument The custom instrument definition
 * @param player The Tone.js player for the instrument
 */
export const registerCustomInstrument = async (
  instrument: MultiKeyInstrument,
  player: any
): Promise<void> => {
  // Store the custom instrument with its player
  CUSTOM_INSTRUMENTS[instrument.id] = {
    instrument,
    player,
  };

  // Add to the main instruments array if not already there
  if (!MULTI_KEY_INSTRUMENTS.find((i) => i.id === instrument.id)) {
    MULTI_KEY_INSTRUMENTS.push(instrument);
  }
};

/**
 * Gets a custom instrument player by ID
 * @param id The instrument ID
 * @returns The player or undefined if not found
 */
export const getCustomInstrumentPlayer = (id: string): any => {
  return CUSTOM_INSTRUMENTS[id]?.player;
};

// Generate waveform data from a Tone.js buffer for visualization
export const generateWaveformData = (
  buffer: Tone.ToneAudioBuffer,
  numPoints: number = 500
): number[] => {
  // Get the raw audio data from the Tone.js buffer
  const channelData = buffer.getChannelData(0);
  const bucketSize = Math.floor(channelData.length / numPoints);

  // Create an array to store waveform points
  const waveform = [];

  // Calculate the peak (positive or negative) value in each bucket
  for (let i = 0; i < numPoints; i++) {
    const start = i * bucketSize;
    const end = start + bucketSize;
    let max = 0;

    for (let j = start; j < end; j++) {
      const absValue = Math.abs(channelData[j]);
      if (absValue > max) {
        max = absValue;
      }
    }

    waveform.push(max);
  }

  return waveform;
};

// Load a sample buffer and extract its waveform data
export const loadSampleAndExtractWaveform = async (
  samplePath: string,
  setWaveformData: (data: number[]) => void,
  setError: (error: string | null) => void
): Promise<{ waveformData: number[]; duration: number } | null> => {
  try {
    // Load the buffer
    const buffer = await Tone.Buffer.fromUrl(normalizeSampleUrl(samplePath));

    // Generate waveform data
    const waveformData = generateWaveformData(buffer);

    // Get the buffer duration in seconds
    const duration = buffer.duration;

    // Set the waveform data in the component state
    setWaveformData(waveformData);

    // Return both waveform data and duration
    return { waveformData, duration };
  } catch (error) {
    console.error("Error loading sample:", error);
    setError("Failed to load the sample waveform");
    return null;
  }
};
